import { localStore } from '@/services/local.storage';

export default function isAdmin ({ next, store }){
    if(!store.getters.auth.loggedIn){
        return next({name:"Login"})
    }
    // console.log(store.getters.auth.isAdmin);
    if(!store.getters.auth.isAdmin){
        if(atob(localStore.getLocalStorage('role'))=='agent')
            return next({  name: 'Agent Dashboard'  });
        if(atob(localStore.getLocalStorage('role'))=='vendor')
            return next({  name: 'Agent Dashboard'  });
    }

    return next()
}